"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const buttonMenu_component_1 = require("./buttonMenu/buttonMenu.component");
const buttonMenuLine_component_1 = require("./buttonMenuLine/buttonMenuLine.component");
const menuButton_component_1 = require("./menuButton/menuButton.component");
const platform_browser_1 = require("@angular/platform-browser");
let ButtonMenuModule = class ButtonMenuModule {
};
ButtonMenuModule = __decorate([
    core_1.NgModule({
        imports: [
            platform_browser_1.BrowserModule,
        ],
        exports: [
            buttonMenu_component_1.ButtonMenuComponent,
        ],
        declarations: [
            buttonMenu_component_1.ButtonMenuComponent,
            buttonMenuLine_component_1.ButtonMenuLineComponent,
            menuButton_component_1.MenuButtonComponent
        ],
        providers: [],
        bootstrap: []
    })
], ButtonMenuModule);
exports.ButtonMenuModule = ButtonMenuModule;
